module.exports = __webpack_public_path__ + "static/media/whatsapp.0e61c241.svg";